import { Component, inject, Input, OnInit } from '@angular/core'
import { StateService } from '../../../services/state.service'
import { BaseComponent } from '../../../components/base.component'

@Component({
    selector: 'app-footer',
    templateUrl: './app-footer.component.html',
    styleUrl: './app-footer.component.scss',
    standalone: false
})
export class AppFooterComponent extends BaseComponent implements OnInit {
  @Input() logoUrl?: string
  @Input() isLoggedIn?: boolean
  stateService = inject(StateService)
  isAttProvider: boolean = false

  private readonly ALWAYS_ATT_TYPES = ['WirelessAccountAuthentication']

  constructor() {
    super()
  }
  ngOnInit(): void {
      this.subscriptions.add(this.stateService.OnSecureDataCurrentUpdate.subscribe((data) => {
        if (data && (data as any).Data) {
          const type = (data as any).Type
          this.isAttProvider = (data as any).Data.internetProvider === 'AT&T'
            || this.ALWAYS_ATT_TYPES.includes(type)
        }
      }))
    }
}
